import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const checkDocumentDatesValidRule: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
	const documentDate = control.get('documentDate')!.value;
	const documentDateInMillis = Date.parse(documentDate);
	const startDate =  Date.parse('01 Jan 1960');
	const nowPlusSixMonths = Date.now() + 15778800000;

	return !!documentDate && !(documentDateInMillis >= startDate && documentDateInMillis <= nowPlusSixMonths) ? { checkDocumentDatesValidFlag: true } : null;
};
